import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';

import FaqCard from '../../components/content/FaqCard';
import { FormattedMessageWrappedInSpan } from '../../components/misc';

const translations = defineMessages({
  whatIsSgDoing: {
    id: 'faqPage.whatIsSgDoing.title',
    defaultMessage: 'What exactly does Sportograf do?',
  },
  whatIsAFotoFlat: {
    id: 'faqPage.whatIsAFotoFlat.title',
    defaultMessage: 'What is a Foto-Flat?',
  },
  howManyPhotosAreInAFotoFlat: {
    id: 'faqPage.howManyPhotosAreInAFotoFlat.title',
    defaultMessage: 'How many photos are in my Foto-Flat?',
  },
  howDoIOrderPhotos: {
    id: 'faqPage.howDoIOrderPhotos.title',
    defaultMessage: 'How do I order photos?',
  },
  canIOrderSingleFotos: {
    id: 'faqPage.canIOrderSingleFotos.title',
    defaultMessage: 'Can I also order individual photos?',
  },
  canIOrderPrintVersion: {
    id: 'faqPage.canIOrderPrintVersion.title',
    defaultMessage: 'Is it possible to order paper prints from Sportograf?',
  },
  whichResolutionHaveThePhotos: {
    id: 'faqPage.whichResolutionHaveThePhotos.title',
    defaultMessage: 'What resolution do my digital photos have?',
  },
  photosAccessTime: {
    id: 'faqPage.photosAccessTime.title',
    defaultMessage: 'How long can I access my photos?',
  },
  photoDvd: {
    id: 'faqPage.photoDvd.title',
    defaultMessage: 'My order on a photo DVD',
  },
  whyDoINotFindFotos: {
    id: 'faqPage.whyDoINotFindFotos.title',
    defaultMessage: "Why can't I find pictures of myself?",
  },
  findAndMarkMorePhotos: {
    id: 'faqPage.findAndMarkMorePhotos.title',
    defaultMessage: 'How do I find and mark (further) photos of me?',
  },
  addPhotosOfOthersToFotoFlat: {
    id: 'faqPage.addPhotosOfOthersToFotoFlat.title',
    defaultMessage: 'Can I add the photos of my friend or group to my Foto-Flat?',
  },
  photosOfOthersAreInMyFotoFlat: {
    id: 'faqPage.photosOfOthersAreInMyFotoFlat.title',
    defaultMessage: 'There are one or more photos of other people in my Foto-Flat.',
  },
  whereIsMyOrder: {
    id: 'faqPage.whereIsMyOrder.title',
    defaultMessage: 'Where is my order?',
  },
  whereIsMyDvd: {
    id: 'faqPage.whereIsMyDvd.title',
    defaultMessage: "My photo DVD hasn't arrived yet.",
  },
  dvdIsBroken: {
    id: 'faqPage.dvdIsBroken.title',
    defaultMessage: 'The photo DVD has arrived broken or scratched.',
  },
  useOfPrepayment: {
    id: 'faqPage.useOfPrepayment.title',
    defaultMessage: 'I would like to pay in advance.',
  },
  refundAndExchange: {
    id: 'faqPage.refundAndExchange.title',
    defaultMessage: 'Refund/Exchange',
  },
  publishOnSocialMedia: {
    id: 'faqPage.publishOnSocialMedia.title',
    defaultMessage: 'Can I publish photos I have bought on social media channels?',
  },
  propagationOfPhotos: {
    id: 'faqPage.propagationOfPhotos.title',
    defaultMessage: 'Did I acquire the rights to further use with the purchase?',
  },
  noAnswerFound: {
    id: 'faqPage.noAnswerFound.title',
    defaultMessage: 'I have read the FAQ and still no solution. Who can I contact?',
  },
  whatIsAFotoFlatListTitleBoldText: {
    id: 'faqPage.whatIsAFotoFlat.listIncludesNot.title.boldText',
    defaultMessage: 'not',
  },
  whatIsAFotoFlatListDescriptionBoldText: {
    id: 'faqPage.whatIsAFotoFlat.listIncludesNot.description1.boldText',
    defaultMessage: 'todo',
  },
  linkToFormText: {
    id: 'faqPage.propagationOfPhotos.description.linkToFormText',
    defaultMessage: 'LINK-TEXT',
  },
});

class FaqPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedCardId: null,
    };

    this.handleExpandClick = this.handleExpandClick.bind(this);
  }

  handleExpandClick(id) {
    this.setState(prevState => ({
      selectedCardId: prevState.selectedCardId === id ? undefined : id,
    }));
  }

  render() {
    const { intl } = this.props;
    const { selectedCardId } = this.state;
    return (
      <div className="container">
        <div className="faq-container">
          {/*
           *
           * Wer oder was ist Sportograf?
           *
           */}
          <h2>
            <FormattedMessageWrappedInSpan id="faqPage.whoIsSg.sectionTitle" />
          </h2>
          <FaqCard
            expanded={selectedCardId === 0}
            onExpandClick={() => this.handleExpandClick(0)}
            title={intl.formatMessage(translations.whatIsSgDoing)}
          >
            <p>
              <FormattedMessageWrappedInSpan id="faqPage.whatIsSgDoing.description" />
            </p>
          </FaqCard>
        </div>

        {/*
         *
         * Wie bestelle ich und was bekomme ich hier?
         *
         */}
        <div className="faq-container">
          <h2>
            <FormattedMessageWrappedInSpan id="faqPage.howCanIOrder.sectionTitle" />
          </h2>

          {/* Was ist eine Foto-Flat? */}
          <FaqCard
            id="what-is-a-foto-flat"
            expanded={selectedCardId === 1}
            onExpandClick={() => this.handleExpandClick(1)}
            title={intl.formatMessage(translations.whatIsAFotoFlat)}
          >
            <p>
              <FormattedMessageWrappedInSpan id="faqPage.whatIsAFotoFlat.description" />
            </p>
            <p>
              <FormattedMessageWrappedInSpan id="faqPage.whatIsAFotoFlat.listIncludes.title" />
            </p>
            <ul>
              <li>
                <FormattedMessageWrappedInSpan id="faqPage.whatIsAFotoFlat.listIncludes.description1" />
              </li>
              <li>
                <FormattedMessageWrappedInSpan id="faqPage.whatIsAFotoFlat.listIncludes.description2" />
              </li>
            </ul>
            <p>
              <FormattedMessageWrappedInSpan
                id="faqPage.whatIsAFotoFlat.listIncludesNot.title.normalText"
                values={{
                  boldText: (
                    <b>
                      {intl.formatMessage(translations.whatIsAFotoFlatListTitleBoldText)}
                    </b>
                  ),
                }}
              />
            </p>
            <ul>
              <li>
                <FormattedMessageWrappedInSpan
                  id="faqPage.whatIsAFotoFlat.listIncludesNot.description1.normalText"
                  values={{
                    boldText: (
                      <b>
                        {intl.formatMessage(
                          translations.whatIsAFotoFlatListDescriptionBoldText
                        )}
                      </b>
                    ),
                  }}
                />
              </li>
              <li>
                <FormattedMessageWrappedInSpan id="faqPage.whatIsAFotoFlat.listIncludesNot.description2" />
              </li>
              <li>
                <FormattedMessageWrappedInSpan id="faqPage.whatIsAFotoFlat.listIncludesNot.description3" />
              </li>
            </ul>
          </FaqCard>

          {/* Wie viele Fotos sind in meiner Foto-Flat? */}
          <FaqCard
            expanded={selectedCardId === 2}
            onExpandClick={() => this.handleExpandClick(2)}
            title={intl.formatMessage(translations.howManyPhotosAreInAFotoFlat)}
          >
            <p>
              <FormattedMessageWrappedInSpan id="faqPage.howManyPhotosAreInAFotoFlat.description" />
            </p>
            <a
              className="faq-card-link"
              href="#find-and-mark-photos"
              onClick={() => this.handleExpandClick(10)}
            >
              <FormattedMessageWrappedInSpan id="faqPage.link.findAndMarkPhotos" />
            </a>
          </FaqCard>

          {/* Wie bestelle ich Fotos? */}
          <FaqCard
            id="how-can-i-order-photos"
            expanded={selectedCardId === 3}
            onExpandClick={() => this.handleExpandClick(3)}
            title={intl.formatMessage(translations.howDoIOrderPhotos)}
          >
            <p>
              <FormattedMessageWrappedInSpan
                id="faqPage.howDoIOrderPhotos.description"
                values={{ br: <br /> }}
              />
            </p>
          </FaqCard>

          {/* Kann ich auch Einzelfotos bestellen? */}
          <FaqCard
            onExpandClick={expanded => this.handleExpandClick(4)}
            expanded={selectedCardId === 4}
            title={intl.formatMessage(translations.canIOrderSingleFotos)}
          >
            <p>
              <FormattedMessageWrappedInSpan id="faqPage.canIOrderSingleFotos.description" />
            </p>
          </FaqCard>

          {/* Ist es möglich Papierabzüge bei Sportograf zu bestellen */}
          <FaqCard
            onExpandClick={expanded => this.handleExpandClick(5)}
            expanded={selectedCardId === 5}
            title={intl.formatMessage(translations.canIOrderPrintVersion)}
          >
            <p>
              <FormattedMessageWrappedInSpan
                id="faqPage.canIOrderPrintVersion.description"
                values={{ br: <br /> }}
              />
            </p>
          </FaqCard>

          {/* Welche Auflösung haben meine digitalen Fotos */}
          <FaqCard
            onExpandClick={expanded => this.handleExpandClick(6)}
            expanded={selectedCardId === 6}
            title={intl.formatMessage(translations.whichResolutionHaveThePhotos)}
          >
            <p>
              <FormattedMessageWrappedInSpan id="faqPage.whichResolutionHaveThePhotos.description" />
            </p>
          </FaqCard>

          {/* Wie lange kann ich auf meine Fotos zugreifen */}
          <FaqCard
            onExpandClick={expanded => this.handleExpandClick(7)}
            expanded={selectedCardId === 7}
            title={intl.formatMessage(translations.photosAccessTime)}
          >
            <p>
              <FormattedMessageWrappedInSpan id="faqPage.photosAccessTime.description" />
            </p>
          </FaqCard>

          {/* Meine Bestellung auf einer Foto-DVD */}
          <FaqCard
            onExpandClick={expanded => this.handleExpandClick(8)}
            expanded={selectedCardId === 8}
            title={intl.formatMessage(translations.photoDvd)}
          >
            <p>
              <FormattedMessageWrappedInSpan
                id="faqPage.photoDvd.description"
                values={{ br: <br /> }}
              />
            </p>
          </FaqCard>
        </div>

        {/*
         *
         * Ich finde keine Fotos von mir, was nun?
         *
         */}
        <div className="faq-container">
          <h2>
            <FormattedMessageWrappedInSpan id="faqPage.noPhotosFound.sectionTitle" />
          </h2>
          {/* Warum finde ich keine Fotos von mir */}
          <FaqCard
            onExpandClick={expanded => this.handleExpandClick(9)}
            expanded={selectedCardId === 9}
            title={intl.formatMessage(translations.whyDoINotFindFotos)}
          >
            <p>
              <FormattedMessageWrappedInSpan id="faqPage.whyDoINotFindFotos.description1" />
            </p>
            <ul>
              <li>
                <FormattedMessageWrappedInSpan id="faqPage.whyDoINotFindFotos.list.description1" />
              </li>
              <li>
                <FormattedMessageWrappedInSpan id="faqPage.whyDoINotFindFotos.list.description2" />
              </li>
            </ul>
            <p>
              <FormattedMessageWrappedInSpan id="faqPage.whyDoINotFindFotos.description2" />
            </p>
            <a
              className="faq-card-link"
              href="#how-can-i-order-photos"
              onClick={() => this.handleExpandClick(3)}
            >
              <FormattedMessageWrappedInSpan id="faqPage.link.howCanIOrderPhotos" />
            </a>
            <a
              className="faq-card-link"
              href="#find-and-mark-photos"
              onClick={() => this.handleExpandClick(10)}
            >
              <FormattedMessageWrappedInSpan id="faqPage.link.findAndMarkPhotos" />
            </a>
          </FaqCard>
          {/* Wie finde und markiere ich (weitere) Fotos von mir? */}
          <FaqCard
            id="find-and-mark-photos"
            onExpandClick={expanded => this.handleExpandClick(10)}
            expanded={selectedCardId === 10}
            title={intl.formatMessage(translations.findAndMarkMorePhotos)}
          >
            <p>
              <FormattedMessageWrappedInSpan id="faqPage.findAndMarkMorePhotos.description1" />
            </p>
            <ul>
              <li>
                <FormattedMessageWrappedInSpan id="faqPage.findAndMarkMorePhotos.smartSearch.title" />
                <p>
                  <FormattedMessageWrappedInSpan id="faqPage.findAndMarkMorePhotos.smartSearch.description" />
                </p>
              </li>
              <li>
                <FormattedMessageWrappedInSpan id="faqPage.findAndMarkMorePhotos.categorySearch.title" />
                <p>
                  <FormattedMessageWrappedInSpan id="faqPage.findAndMarkMorePhotos.categorySearch.description" />
                </p>
              </li>
              <li>
                <FormattedMessageWrappedInSpan id="faqPage.findAndMarkMorePhotos.gpsSearch.title" />
                <p>
                  <FormattedMessageWrappedInSpan id="faqPage.findAndMarkMorePhotos.gpsSearch.description" />
                </p>
              </li>
            </ul>
            <p>
              <FormattedMessageWrappedInSpan id="faqPage.findAndMarkMorePhotos.description2" />
            </p>
            <p>
              <FormattedMessageWrappedInSpan
                id="faqPage.findAndMarkMorePhotos.description3"
                values={{ br: <br /> }}
              />
            </p>
          </FaqCard>
          {/* Kann ich die Fotos meiner/s Freundes/in oder meiner Gruppe zu meiner Foto-Flat hinzufügen? */}
          <FaqCard
            onExpandClick={expanded => this.handleExpandClick(11)}
            expanded={selectedCardId === 11}
            title={intl.formatMessage(translations.addPhotosOfOthersToFotoFlat)}
          >
            <p>
              <FormattedMessageWrappedInSpan id="faqPage.addPhotosOfOthersToFotoFlat.description1" />
            </p>
            <a
              className="faq-card-link"
              href="#what-is-a-foto-flat"
              onClick={() => this.handleExpandClick(1)}
            >
              <FormattedMessageWrappedInSpan id="faqPage.link.whatIsAFotoFlat" />
            </a>
            <a
              className="faq-card-link"
              href="#find-and-mark-photos"
              onClick={() => this.handleExpandClick(10)}
            >
              <FormattedMessageWrappedInSpan id="faqPage.link.findAndMarkPhotos" />
            </a>
          </FaqCard>
          {/* Es gibt ein order mehrere Fotos fremder Personen in meiner Foto-Flat? */}
          <FaqCard
            onExpandClick={expanded => this.handleExpandClick(12)}
            expanded={selectedCardId === 12}
            title={intl.formatMessage(translations.photosOfOthersAreInMyFotoFlat)}
          >
            <p>
              <FormattedMessageWrappedInSpan
                id="faqPage.photosOfOthersAreInMyFotoFlat.description1"
                values={{ br: <br /> }}
              />
            </p>
          </FaqCard>
        </div>
        {/*
         *
         * Wo bleibt meine Bestellung
         *
         */}
        <div className="faq-container">
          <h2>
            <FormattedMessageWrappedInSpan id="faqPage.whereIsMyOrder.sectionTitle" />
          </h2>
          {/* Wo ist meine Bestellung */}
          <FaqCard
            onExpandClick={expanded => this.handleExpandClick(13)}
            expanded={selectedCardId === 13}
            title={intl.formatMessage(translations.whereIsMyOrder)}
          >
            <p>
              <FormattedMessageWrappedInSpan id="faqPage.whereIsMyOrder.description1" />
            </p>
            <ul>
              <li>
                <FormattedMessageWrappedInSpan id="faqPage.whereIsMyOrder.list.description1" />
              </li>
              <li>
                <FormattedMessageWrappedInSpan id="faqPage.whereIsMyOrder.list.description2" />
              </li>
            </ul>
            <p>
              <FormattedMessageWrappedInSpan id="faqPage.whereIsMyOrder.description2" />
            </p>
            <p>
              <FormattedMessageWrappedInSpan id="faqPage.whereIsMyOrder.description3" />
            </p>
          </FaqCard>
          {/* Meine Foto-DVD ist noch nicht angekommen */}
          <FaqCard
            onExpandClick={expanded => this.handleExpandClick(14)}
            expanded={selectedCardId === 14}
            title={intl.formatMessage(translations.whereIsMyDvd)}
          >
            <p>
              <FormattedMessageWrappedInSpan
                id="faqPage.whereIsMyDvd.description"
                values={{ br: <br /> }}
              />
            </p>
          </FaqCard>
          {/* Die Foto-DVD ist gebrochen oder zekratzt angekommen */}
          <FaqCard
            onExpandClick={expanded => this.handleExpandClick(15)}
            expanded={selectedCardId === 15}
            title={intl.formatMessage(translations.dvdIsBroken)}
          >
            <p>
              <FormattedMessageWrappedInSpan
                id="faqPage.dvdIsBroken.description"
                values={{ br: <br /> }}
              />
            </p>
          </FaqCard>
          {/* TODO: Title */}
          <FaqCard
            onExpandClick={expanded => this.handleExpandClick(16)}
            expanded={selectedCardId === 16}
            title={intl.formatMessage(translations.useOfPrepayment)}
          >
            <p>
              <FormattedMessageWrappedInSpan id="faqPage.useOfPrepayment.description" />
            </p>
          </FaqCard>
          {/* TODO: Title */}
          <FaqCard
            onExpandClick={expanded => this.handleExpandClick(17)}
            expanded={selectedCardId === 17}
            title={intl.formatMessage(translations.refundAndExchange)}
          >
            <p>
              <FormattedMessageWrappedInSpan id="faqPage.refundAndExchange.description" />
            </p>
          </FaqCard>
        </div>
        {/*
         *
         * Verwendung der Fotos - Bildrecht, Uhrheberrecht, Presse
         *
         */}
        <div className="faq-container">
          <h2>
            <FormattedMessageWrappedInSpan id="faqPage.publish.sectionTitle" />
          </h2>
          {/* TODO: Title */}
          <FaqCard
            onExpandClick={expanded => this.handleExpandClick(18)}
            expanded={selectedCardId === 18}
            title={intl.formatMessage(translations.publishOnSocialMedia)}
          >
            <p>
              <FormattedMessageWrappedInSpan id="faqPage.publishOnSocialMedia.description" />
            </p>
          </FaqCard>
          <FaqCard
            onExpandClick={expanded => this.handleExpandClick(19)}
            expanded={selectedCardId === 19}
            title={intl.formatMessage(translations.propagationOfPhotos)}
          >
            <p>
              <FormattedMessageWrappedInSpan
                id="faqPage.propagationOfPhotos.description.text"
                values={{
                  linkToFormText: (
                    <a
                      className="faq-card-link-without-margin"
                      href="https://docs.google.com/forms/d/e/1FAIpQLSd_gJlSvPmZsoOOWhmDtb9pno7TSWeUpQcaPlWX3X8tEbUkGg/viewform"
                      target="_blank"
                      rel="noreferrer noopener"
                    >
                      {intl.formatMessage(translations.linkToFormText)}
                    </a>
                  ),
                }}
              />
            </p>
          </FaqCard>
        </div>
        {/*
         *
         * Keine Antwort gefunden?
         *
         */}
        <div className="faq-container">
          <h2>
            <FormattedMessageWrappedInSpan id="faqPage.noAnswerFound.sectionTitle" />
          </h2>
          {/* TODO: Title */}
          <FaqCard
            onExpandClick={expanded => this.handleExpandClick(20)}
            expanded={selectedCardId === 20}
            title={intl.formatMessage(translations.noAnswerFound)}
          >
            <p>
              <FormattedMessageWrappedInSpan id="faqPage.noAnswerFound.description1" />
            </p>
          </FaqCard>
        </div>
      </div>
    );
  }
}

FaqPage.propTypes = {
  intl: PropTypes.object,
};

export default injectIntl(FaqPage);
